/** @format */

import { ProductContainerComponent } from './product/product-container/product-container.component';
import { ProductResolveGuard } from './product/product-resolve.guard';
import { ProductReviewsResolver } from '@product-reviews/data-access';
import { Routes } from '@angular/router';

/*
 * Standalone App Routes
 */
export const PRODUCT_APP_ROUTES: Routes = [
	{
		path: 'p/:seoToken/:partNumber',
		component: ProductContainerComponent,
		resolve: { data: ProductResolveGuard, reviews: ProductReviewsResolver }
	},
	{
		path: 'p/:seoToken',
		component: ProductContainerComponent,
		resolve: { data: ProductResolveGuard, reviews: ProductReviewsResolver }
	}
];
